export default () => {
  /*   uat */
  // return "https://papan2-api.techbasemlm.com";

  //new one
  return "https://papan2-api-live.techbasemlm.com";
};
